(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc_default_footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 991px)');
    var uid = 0;

    function toggle(menu, label) {
      var open = menu.classList.toggle('is-open');
      label.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function setup() {
      document.querySelectorAll('.footer-sc-grp .blck-menu').forEach(function (menu) {
        var label = menu.querySelector('.blck-menu-label');
        var list = menu.querySelector('.blck-menu-list-item');
        // Labels that are links keep working as links
        if (!label || !list || label.querySelector('a')) return;

        if (!menu.dataset.footerAccordion) {
          menu.dataset.footerAccordion = 'true';
          if (!list.id) list.id = 'FooterMenuList-' + ++uid;
          label.addEventListener('click', function () {
            if (mq.matches) toggle(menu, label);
          });
          label.addEventListener('keydown', function (event) {
            if (!mq.matches || (event.key !== 'Enter' && event.key !== ' ')) return;
            event.preventDefault();
            toggle(menu, label);
          });
        }

        if (mq.matches) {
          menu.classList.add('is-footer-accordion');
          label.setAttribute('role', 'button');
          label.setAttribute('tabindex', '0');
          label.setAttribute('aria-controls', list.id);
          label.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
        } else {
          menu.classList.remove('is-footer-accordion');
          ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (name) {
            label.removeAttribute(name);
          });
        }
      });
    }

    setup();
    mq.addEventListener('change', setup);
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc_scent_finder"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Scent engine: note knowledge + matching ---------- */
  var ScentEngine = (function () {
    var FACETS = ['citrus', 'fresh', 'green', 'fruity', 'floral', 'spicy', 'sweet', 'woody', 'amber', 'musk', 'leather'];

    // Note knowledge base. First keyword found inside a note name wins, so specific entries come first.
    // [keyword, canonical name, accords]
    var NOTES = [
      ['orange blossom', 'Orange Blossom', { floral: 1, citrus: 0.3 }],
      ['neroli', 'Neroli', { floral: 0.8, citrus: 0.5 }],
      ['violet leaf', 'Violet Leaf', { green: 0.9, fresh: 0.4 }],
      ['green tea', 'Green Tea', { green: 1, fresh: 0.4 }],
      ['lapsang', 'Smoked Tea', { leather: 0.8, green: 0.5 }],
      ['tea', 'Tea', { green: 0.9, fresh: 0.3 }],
      ['green apple', 'Green Apple', { fruity: 0.9, green: 0.4, fresh: 0.3 }],
      ['passion fruit', 'Passion Fruit', { fruity: 1 }],
      ['dragon fruit', 'Dragon Fruit', { fruity: 1 }],
      ['red berries', 'Red Berries', { fruity: 1, sweet: 0.3 }],
      ['pink pepper', 'Pink Pepper', { spicy: 0.9, fresh: 0.2 }],
      ['black pepper', 'Black Pepper', { spicy: 1 }],
      ['pepper', 'Pepper', { spicy: 1 }],
      ['brown sugar', 'Brown Sugar', { sweet: 1 }],
      ['cocoa', 'Cocoa', { sweet: 0.9, amber: 0.3 }],
      ['coffee', 'Coffee', { sweet: 0.7, leather: 0.4, amber: 0.3 }],
      ['cognac', 'Cognac', { amber: 0.7, sweet: 0.6 }],
      ['caramel', 'Caramel', { sweet: 1 }],
      ['praline', 'Praline', { sweet: 1 }],
      ['toffee', 'Toffee', { sweet: 1 }],
      ['vanilla', 'Vanilla', { sweet: 1, amber: 0.3 }],
      ['tonka', 'Tonka Bean', { sweet: 0.8, amber: 0.5 }],
      ['benzoin', 'Benzoin', { amber: 0.8, sweet: 0.5 }],
      ['bergamot', 'Bergamot', { citrus: 1, fresh: 0.3 }],
      ['lemon', 'Lemon', { citrus: 1, fresh: 0.4 }],
      ['grapefruit', 'Grapefruit', { citrus: 1, fresh: 0.3 }],
      ['mandarin', 'Mandarin', { citrus: 1, fruity: 0.3 }],
      ['orange', 'Orange', { citrus: 1, fruity: 0.3 }],
      ['petitgrain', 'Petitgrain', { citrus: 0.7, green: 0.6 }],
      ['verbena', 'Verbena', { citrus: 0.7, green: 0.6 }],
      ['citrus', 'Citrus', { citrus: 1 }],
      ['seaweed', 'Seaweed', { fresh: 1, green: 0.3 }],
      ['sea', 'Sea Notes', { fresh: 1 }],
      ['marine', 'Marine Accord', { fresh: 1 }],
      ['calone', 'Calone', { fresh: 1 }],
      ['water', 'Watery Notes', { fresh: 1 }],
      ['salt', 'Sea Salt', { fresh: 0.9 }],
      ['mint', 'Mint', { fresh: 0.9, green: 0.6 }],
      ['bamboo', 'Bamboo', { green: 1, fresh: 0.3 }],
      ['clary sage', 'Clary Sage', { green: 1 }],
      ['sage', 'Sage', { green: 1 }],
      ['lavender', 'Lavender', { green: 0.8, fresh: 0.3, floral: 0.3 }],
      ['geranium', 'Geranium', { green: 0.6, floral: 0.5 }],
      ['herb', 'Aromatic Herbs', { green: 1 }],
      ['aromatic spice', 'Aromatic Spices', { spicy: 1 }],
      ['aromatic', 'Aromatic Notes', { green: 0.9 }],
      ['green', 'Green Notes', { green: 1 }],
      ['pineapple', 'Pineapple', { fruity: 1, fresh: 0.2 }],
      ['apple', 'Apple', { fruity: 1 }],
      ['pear', 'Pear', { fruity: 1 }],
      ['blackcurrant', 'Blackcurrant', { fruity: 1 }],
      ['mango', 'Mango', { fruity: 1, sweet: 0.3 }],
      ['strawberry', 'Strawberry', { fruity: 1, sweet: 0.3 }],
      ['lychee', 'Lychee', { fruity: 1 }],
      ['kiwi', 'Kiwi', { fruity: 1, fresh: 0.2 }],
      ['peach', 'Peach', { fruity: 1, sweet: 0.2 }],
      ['tropical', 'Tropical Fruits', { fruity: 1 }],
      ['fruit', 'Fruity Notes', { fruity: 1 }],
      ['osmanthus', 'Osmanthus', { floral: 0.8, fruity: 0.4 }],
      ['jasmine', 'Jasmine', { floral: 1 }],
      ['tuberose', 'Tuberose', { floral: 1 }],
      ['rose', 'Rose', { floral: 1 }],
      ['peony', 'Peony', { floral: 1 }],
      ['iris', 'Iris', { floral: 0.7, musk: 0.6 }],
      ['orris', 'Iris', { floral: 0.7, musk: 0.6 }],
      ['violet', 'Violet', { floral: 0.8, musk: 0.4 }],
      ['muguet', 'Lily of the Valley', { floral: 1, green: 0.3 }],
      ['lily', 'Lily of the Valley', { floral: 1, green: 0.3 }],
      ['marigold', 'Marigold', { floral: 0.8, green: 0.3 }],
      ['bellflower', 'Bellflower', { floral: 1 }],
      ['wisteria', 'Wisteria', { floral: 1 }],
      ['lilac', 'Lilac', { floral: 1, green: 0.2 }],
      ['orchid', 'Orchid', { floral: 0.8, sweet: 0.4 }],
      ['hedione', 'Hedione', { floral: 0.7, fresh: 0.4 }],
      ['mahonial', 'Mahonial', { floral: 0.8 }],
      ['floral', 'Floral Notes', { floral: 1 }],
      ['cinnamon', 'Cinnamon', { spicy: 1, sweet: 0.3 }],
      ['cardamom', 'Cardamom', { spicy: 0.9, fresh: 0.2 }],
      ['saffron', 'Saffron', { spicy: 0.8, leather: 0.5 }],
      ['ginger', 'Ginger', { spicy: 0.8, fresh: 0.3 }],
      ['nutmeg', 'Nutmeg', { spicy: 1 }],
      ['elemi', 'Elemi', { spicy: 0.5, amber: 0.5, fresh: 0.3 }],
      ['spic', 'Spices', { spicy: 1 }],
      ['suede', 'Suede', { leather: 0.9, musk: 0.3 }],
      ['leather', 'Leather', { leather: 1 }],
      ['birch', 'Birch', { leather: 0.8, woody: 0.5 }],
      ['smok', 'Smoky Notes', { leather: 0.9, woody: 0.3 }],
      ['incense', 'Incense', { amber: 0.8, leather: 0.5 }],
      ['labdanum', 'Labdanum', { amber: 1, leather: 0.3 }],
      ['resin', 'Resins', { amber: 1 }],
      ['amberwood', 'Amberwood', { woody: 0.8, amber: 0.7 }],
      ['amber wood', 'Amberwood', { woody: 0.8, amber: 0.7 }],
      ['ambergris', 'Ambergris', { amber: 0.8, fresh: 0.3, musk: 0.3 }],
      ['ambroxan', 'Ambroxan', { amber: 0.8, musk: 0.4, fresh: 0.2 }],
      ['ambrofix', 'Ambroxan', { amber: 0.8, musk: 0.4, fresh: 0.2 }],
      ['ambrette', 'Ambrette', { musk: 1, floral: 0.2 }],
      ['amber', 'Amber', { amber: 1, sweet: 0.2 }],
      ['cashmeran', 'Cashmeran', { woody: 0.7, musk: 0.7 }],
      ['akigalawood', 'Akigalawood', { woody: 0.9, spicy: 0.4 }],
      ['sandalwood', 'Sandalwood', { woody: 1, musk: 0.3 }],
      ['cedar', 'Cedarwood', { woody: 1 }],
      ['vetiver', 'Vetiver', { woody: 0.9, green: 0.4 }],
      ['patchouli', 'Patchouli', { woody: 0.8, amber: 0.4 }],
      ['oakmoss', 'Oakmoss', { woody: 0.7, green: 0.6 }],
      ['guaiac', 'Guaiac Wood', { woody: 0.9, leather: 0.4 }],
      ['papyrus', 'Papyrus', { woody: 0.9, green: 0.2 }],
      ['cypriol', 'Cypriol', { woody: 0.8, leather: 0.5 }],
      ['wood', 'Woody Notes', { woody: 1 }],
      ['powder', 'Powdery Notes', { musk: 0.9, floral: 0.3 }],
      ['musk', 'Musk', { musk: 1 }]
    ];

    // Everyday words people use to describe a scent -> accords
    var WORDS = {
      fresh: { fresh: 1, citrus: 0.7, green: 0.4 }, clean: { fresh: 0.9, musk: 0.7, citrus: 0.5 }, crisp: { fresh: 1, citrus: 0.6, green: 0.4 },
      airy: { fresh: 0.8, musk: 0.6 }, soapy: { musk: 1, fresh: 0.5 }, shower: { fresh: 1, musk: 0.5 }, cool: { fresh: 1, green: 0.4 },
      ocean: { fresh: 1 }, oceanic: { fresh: 1 }, aquatic: { fresh: 1 }, beachy: { fresh: 1, citrus: 0.5, fruity: 0.3 }, breezy: { fresh: 1, citrus: 0.5 },
      zesty: { citrus: 1, fresh: 0.4 }, citrusy: { citrus: 1 }, tangy: { citrus: 1, fruity: 0.4 },
      sweet: { sweet: 1, fruity: 0.3 }, sugary: { sweet: 1 }, dessert: { sweet: 1 }, gourmand: { sweet: 1, amber: 0.3 }, candy: { sweet: 1, fruity: 0.5 },
      creamy: { sweet: 0.7, musk: 0.5, woody: 0.3 }, yummy: { sweet: 1 }, edible: { sweet: 1 }, chocolate: { sweet: 1, amber: 0.3 }, honey: { sweet: 1, amber: 0.4 },
      warm: { amber: 1, sweet: 0.6, spicy: 0.4 }, cozy: { sweet: 0.9, amber: 0.9, musk: 0.3 }, cosy: { sweet: 0.9, amber: 0.9, musk: 0.3 },
      comforting: { sweet: 0.9, amber: 0.8, musk: 0.4 }, spicy: { spicy: 1 }, peppery: { spicy: 1 }, hot: { spicy: 0.8, amber: 0.5 },
      woody: { woody: 1 }, woodsy: { woody: 1 }, forest: { woody: 0.9, green: 0.8 }, earthy: { woody: 0.9, green: 0.5 }, mossy: { woody: 0.6, green: 0.8 },
      oud: { woody: 0.9, leather: 0.7, amber: 0.5 }, floral: { floral: 1 }, flowery: { floral: 1 }, flowers: { floral: 1 }, flower: { floral: 1 },
      bouquet: { floral: 1 }, romantic: { floral: 0.8, sweet: 0.5, musk: 0.4 }, fruity: { fruity: 1 }, juicy: { fruity: 1, citrus: 0.4 },
      berry: { fruity: 1 }, berries: { fruity: 1 }, musky: { musk: 1 }, powdery: { musk: 0.9, floral: 0.4 }, soft: { musk: 0.9, floral: 0.4 },
      skin: { musk: 1 }, smoky: { leather: 1, woody: 0.4 }, smokey: { leather: 1, woody: 0.4 }, leathery: { leather: 1 }, dark: { leather: 0.8, amber: 0.8, woody: 0.5 },
      mysterious: { amber: 0.9, leather: 0.7, spicy: 0.5 }, deep: { amber: 0.8, woody: 0.8 }, rich: { amber: 0.9, sweet: 0.5, woody: 0.4 },
      oriental: { amber: 1, spicy: 0.7, sweet: 0.4 }, arabian: { amber: 1, spicy: 0.7, leather: 0.5, woody: 0.5 }, herbal: { green: 1 }, natural: { green: 0.9, woody: 0.4 },
      sexy: { amber: 0.9, sweet: 0.6, musk: 0.6 }, seductive: { amber: 0.9, sweet: 0.6, spicy: 0.5 }, sensual: { amber: 0.8, musk: 0.8, sweet: 0.4 },
      elegant: { floral: 0.6, woody: 0.6, musk: 0.5 }, classy: { woody: 0.7, amber: 0.5, musk: 0.4 }, sophisticated: { woody: 0.7, amber: 0.5, floral: 0.4 },
      luxurious: { amber: 0.7, woody: 0.6, leather: 0.4 }, masculine: { woody: 0.8, leather: 0.5, green: 0.4 }, feminine: { floral: 0.9, fruity: 0.4, musk: 0.4 },
      playful: { fruity: 0.9, sweet: 0.6 }, fun: { fruity: 0.9, sweet: 0.5, citrus: 0.4 }, energetic: { citrus: 1, fresh: 0.6, fruity: 0.4 },
      sporty: { fresh: 1, citrus: 0.8, green: 0.4 }, exotic: { fruity: 0.7, spicy: 0.6, amber: 0.5 },
      athlete: { fresh: 1, citrus: 0.8, green: 0.4 }, athletic: { fresh: 1, citrus: 0.8, green: 0.4 }, sport: { fresh: 1, citrus: 0.8, green: 0.4 },
      workout: { fresh: 1, citrus: 0.8, green: 0.4 }, training: { fresh: 1, citrus: 0.8, green: 0.4 }, active: { fresh: 1, citrus: 0.7, green: 0.4 },
      running: { fresh: 1, citrus: 0.8, green: 0.4 }, football: { fresh: 1, citrus: 0.8, green: 0.4 }, sweat: { fresh: 1, citrus: 0.7, musk: 0.4 },
      sweaty: { fresh: 1, citrus: 0.7, musk: 0.4 }, outdoors: { green: 0.9, fresh: 0.7, woody: 0.5 }, hiking: { green: 0.9, woody: 0.7, fresh: 0.5 },
      travel: { fresh: 0.8, citrus: 0.6, woody: 0.3 }, professional: { woody: 0.6, fresh: 0.5, musk: 0.5 }, confident: { woody: 0.7, spicy: 0.5, amber: 0.5 },
      manly: { woody: 0.8, leather: 0.5, green: 0.4 }, girly: { fruity: 0.8, floral: 0.8, sweet: 0.5 }, relaxing: { green: 0.8, musk: 0.6, woody: 0.4 },
      calm: { green: 0.7, musk: 0.6, woody: 0.5 }, happy: { citrus: 0.9, fruity: 0.7 }, expensive: { amber: 0.7, woody: 0.7, leather: 0.4 },
      citrus: { citrus: 1 }, wood: { woody: 1 }, fruit: { fruity: 1 }, spice: { spicy: 1 }, green: { green: 1 }, aromatic: { green: 0.9 },
      marine: { fresh: 1 }, sea: { fresh: 1 }, water: { fresh: 1 }, watery: { fresh: 1 }, gourmet: { sweet: 1 }
    };

    var VIBES = {
      fresh: { citrus: 1, fresh: 1, green: 0.7, musk: 0.3 },
      cozy: { sweet: 1, amber: 1, woody: 0.4, spicy: 0.3, musk: 0.3 },
      bold: { spicy: 1, leather: 0.9, amber: 0.6, woody: 0.6 },
      fruity: { fruity: 1, sweet: 0.7, citrus: 0.3 },
      floral: { floral: 1, musk: 0.6, fruity: 0.2 },
      woody: { woody: 1, green: 0.5, amber: 0.4, musk: 0.3 }
    };

    // Occasion: accords it leans on, strength bias, and words that mark it in a product's "Best for ..." line
    var OCCASIONS = {
      everyday: { v: { citrus: 0.6, fresh: 0.6, green: 0.5, musk: 0.5, woody: 0.3 }, i: -0.3, words: ['office', 'work', 'daily', 'everyday', 'every day', 'day wear', 'daytime', 'casual', 'gym', 'school', 'meeting'] },
      date: { v: { sweet: 0.7, amber: 0.7, spicy: 0.4, floral: 0.4, musk: 0.4 }, i: 0.3, words: ['date', 'romantic', 'romance', 'evening', 'dinner', 'intimate'] },
      night: { v: { sweet: 0.6, amber: 0.6, spicy: 0.6, fruity: 0.5, leather: 0.4 }, i: 0.5, words: ['party', 'parties', 'night out', 'nights out', 'club', 'clubbing', 'celebrat'] },
      sunny: { v: { citrus: 0.9, fresh: 0.9, fruity: 0.6, green: 0.4 }, i: -0.5, words: ['summer', 'beach', 'hot ', 'vacation', 'holiday', 'spring', 'sunny', 'pool', 'brunch'] },
      special: { v: { woody: 0.6, amber: 0.6, floral: 0.5, leather: 0.4, spicy: 0.4 }, i: 0.3, words: ['special', 'wedding', 'formal', 'occasion', 'gala', 'event', 'signature', 'gift'] },
      cold: { v: { amber: 0.9, sweet: 0.7, spicy: 0.6, woody: 0.5 }, i: 0.4, words: ['winter', 'cold', 'autumn', 'fall ', 'cool evening', 'cooler'] }
    };

    var GENDER_WORDS = {
      men: ['men', 'man', 'him', 'male', 'guy', 'husband', 'boyfriend', 'dad', 'father', 'brother', 'groom', 'mens', 'gentleman'],
      women: ['women', 'woman', 'her', 'female', 'lady', 'girl', 'wife', 'girlfriend', 'mom', 'mum', 'mother', 'sister', 'bride', 'womens', 'ladies']
    };
    var STRONG_WORDS = ['strong', 'bold', 'powerful', 'intense', 'loud', 'heavy', 'beast', 'projection', 'noticeable'];
    // Staying power is its own wish: a fresh scent can be asked to last without being asked to be heavy
    var LASTING_WORDS = ['long lasting', 'longlasting', 'lasting', 'lasts', 'stay', 'stays', 'fade', 'fades', 'all day', 'whole day', 'hours', 'the same', 'after the', 'after a',
      'after my', 'endurance', 'sweat', 'sweaty', 'athlete', 'athletic', 'workout', 'training', 'game', 'longevity'];
    // Everyday words that sit one typo away from scent vocabulary and must not be "corrected" into it
    var NOT_TYPOS = ['there', 'these', 'those', 'their', 'where', 'which', 'while', 'would', 'could', 'should', 'about', 'after', 'other', 'smell', 'smells', 'really', 'think',
      'thing', 'great', 'perfume', 'perfumes', 'scent', 'scents', 'fragrance', 'something', 'someone', 'always', 'every', 'still', 'please', 'thanks', 'makes', 'people',
      'wants', 'needs', 'looks', 'feels', 'first', 'going', 'being', 'having', 'swear', 'sweep', 'sheet', 'short', 'sport', 'store', 'clear', 'wears', 'lasted'];
    var LIGHT_WORDS = ['subtle', 'light', 'mild', 'gentle', 'delicate', 'discreet', 'quiet', 'soft'];
    var NEGATORS = ['no', 'not', 'without', 'hate', 'dislike', 'avoid', 'less', 'never', 'nothing', 'dont', 'isnt', 'cant', 'too', 'overly', 'except'];
    var POSITIVES = ['love', 'like', 'want', 'prefer', 'need', 'enjoy', 'adore', 'but', 'with', 'looking'];

    var LAYER_WEIGHT = { top: 0.7, heart: 1, base: 1.1 };

    function emptyVec() { var v = {}; FACETS.forEach(function (f) { v[f] = 0; }); return v; }
    function addVec(target, source, weight) { for (var k in source) { if (k in target) target[k] += source[k] * (weight == null ? 1 : weight); } return target; }
    function maxOf(v) { var m = 0; FACETS.forEach(function (f) { if (v[f] > m) m = v[f]; }); return m; }
    function normalise(v) { var m = maxOf(v); var out = emptyVec(); if (m > 0) FACETS.forEach(function (f) { out[f] = Math.max(0, v[f]) / m; }); return out; }
    function cosine(a, b) {
      var dot = 0, na = 0, nb = 0;
      FACETS.forEach(function (f) { var x = Math.max(0, a[f]), y = Math.max(0, b[f]); dot += x * y; na += x * x; nb += y * y; });
      return na && nb ? dot / Math.sqrt(na * nb) : 0;
    }
    function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

    function lookupNote(raw) {
      var name = String(raw || '').toLowerCase().replace(/\(.*?\)/g, ' ').replace(/[^a-z\s\-\/]/g, ' ').replace(/\s+/g, ' ').trim();
      if (!name) return null;
      for (var i = 0; i < NOTES.length; i++) {
        if (name.indexOf(NOTES[i][0]) !== -1) return { key: NOTES[i][1].toLowerCase(), name: NOTES[i][1], facets: NOTES[i][2] };
      }
      return null;
    }

    // Reads "Top Notes: a, b" / "Heart Notes: ..." / "Base Notes: ..." out of a product description
    function parsePyramid(html) {
      var text = String(html || '').replace(/<[^>]+>/g, '|').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ');
      var layers = { top: [], heart: [], base: [] };
      var re = /(top|head|middle|heart|base)\s*notes?\s*:?[\s|]*([^|]+)/gi, match;
      while ((match = re.exec(text))) {
        var label = match[1].toLowerCase();
        var layer = label === 'top' || label === 'head' ? 'top' : label === 'base' ? 'base' : 'heart';
        if (layers[layer].length) continue;
        match[2].split(/,|;|•/).forEach(function (part) {
          var note = part.replace(/\s+/g, ' ').replace(/[.\s]+$/, '').trim();
          if (note && note.length < 40) layers[layer].push(note);
        });
      }
      return layers;
    }

    // Product -> accord profile, canonical notes and strength
    function profile(product) {
      var layers = product.pyramid || parsePyramid(product.desc);
      var vec = emptyVec(), notes = [], seen = {};
      ['top', 'heart', 'base'].forEach(function (layer) {
        layers[layer].forEach(function (raw) {
          var hit = lookupNote(raw);
          notes.push({ raw: raw, layer: layer, key: hit ? hit.key : raw.toLowerCase(), name: hit ? hit.name : raw, facets: hit ? hit.facets : {} });
          if (hit) { addVec(vec, hit.facets, LAYER_WEIGHT[layer]); seen[hit.key] = true; }
        });
      });
      (product.main || []).forEach(function (main) {
        var hit = lookupNote(main.l);
        if (hit) { addVec(vec, hit.facets, 0.8); seen[hit.key] = true; }
      });
      var total = 0; FACETS.forEach(function (f) { total += vec[f]; });
      var heavy = vec.amber + vec.leather + vec.spicy + vec.sweet + vec.woody * 0.6;
      var light = vec.citrus + vec.fresh + vec.green + vec.fruity * 0.4;
      var strength = total ? (heavy - light) / total : 0;
      if (/extrait/i.test(product.conc || '')) strength += 0.2;
      var anchors = [];
      notes.forEach(function (note) {
        var holds = (note.facets.woody || 0) >= 0.7 || (note.facets.amber || 0) >= 0.7 || (note.facets.musk || 0) >= 0.7 || (note.facets.leather || 0) >= 0.7;
        if (note.layer === 'base' && holds && anchors.indexOf(note.name) === -1) anchors.push(note.name);
      });
      return {
        layers: layers, notes: notes, keys: seen, vec: normalise(vec), strength: clamp(strength * 1.6, -1, 1),
        extrait: /extrait/i.test(product.conc || ''), anchors: anchors
      };
    }

    // Edit distance with swapped neighbours counted once ("vanlila" -> "vanilla")
    function distance(a, b) {
      var rows = [], i, j;
      for (i = 0; i <= a.length; i++) { rows[i] = [i]; }
      for (j = 1; j <= b.length; j++) { rows[0][j] = j; }
      for (i = 1; i <= a.length; i++) {
        for (j = 1; j <= b.length; j++) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + cost);
          if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
        }
      }
      return rows[a.length][b.length];
    }

    var knownWords = null;
    function known() {
      if (knownWords) return knownWords;
      var seen = {};
      function add(word) { word = String(word).trim(); if (word.length >= 5 && word.indexOf(' ') === -1) seen[word] = true; }
      Object.keys(WORDS).forEach(add);
      NOTES.forEach(function (entry) { add(entry[0]); add(entry[1].toLowerCase()); });
      for (var occasion in OCCASIONS) OCCASIONS[occasion].words.forEach(add);
      GENDER_WORDS.men.concat(GENDER_WORDS.women, STRONG_WORDS, LIGHT_WORDS, LASTING_WORDS).forEach(add);
      knownWords = Object.keys(seen);
      return knownWords;
    }
    // "athelete" -> "athlete", "vanila" -> "vanilla". Same first letter, one slip (two in long words).
    function fixTypo(word) {
      if (word.length < 5 || NOT_TYPOS.indexOf(word) !== -1) return null;
      var list = known(), allowed = word.length >= 8 ? 2 : 1, best = null, bestDistance = allowed + 1;
      for (var i = 0; i < list.length; i++) {
        var candidate = list[i];
        if (candidate === word) return null;
        if (candidate.charAt(0) !== word.charAt(0) || Math.abs(candidate.length - word.length) > allowed) continue;
        var d = distance(word, candidate);
        if (d < bestDistance) { best = candidate; bestDistance = d; }
      }
      return best;
    }

    function tokens(text) {
      return String(text || '').toLowerCase().replace(/[’']/g, '').replace(/([,.;!?\n])/g, ' $1 ').replace(/[^a-z0-9,.;!?\s\-]/g, ' ').split(/\s+/).filter(Boolean);
    }

    // Whole-phrase note lookup for typed text ("rose", "orange blossom", "woods")
    function exactNote(chunk) {
      for (var i = 0; i < NOTES.length; i++) {
        if (chunk === NOTES[i][0] || chunk === NOTES[i][1].toLowerCase()) return { key: NOTES[i][1].toLowerCase(), name: NOTES[i][1], facets: NOTES[i][2] };
      }
      return null;
    }

    // Free text -> preferences
    function readText(text) {
      var words = tokens(text);
      var out = { vec: emptyVec(), loves: [], avoids: [], gender: null, occasion: null, intensity: 0, lasting: false, hits: 0 };
      var negate = false, lastNegator = -9, corrected = {};

      function singular(word) { return word.length > 4 && /s$/.test(word) ? word.replace(/ies$/, 'y').replace(/s$/, '') : word; }
      function inList(list, a, b) { return list.some(function (w) { w = w.trim(); return w === a || w === b; }); }

      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (/^[,.;!?]$/.test(word)) { negate = false; continue; }
        if (NEGATORS.indexOf(word) !== -1) { negate = true; lastNegator = i; continue; }
        if (POSITIVES.indexOf(word) !== -1) { if (i - lastNegator > 1) negate = false; continue; }

        for (var n = 3; n >= 1; n--) {
          if (i + n > words.length) continue;
          var chunk = words.slice(i, i + n).join(' ');
          var single = n === 1 ? singular(chunk) : chunk.replace(/s$/, '');
          var matched = false;

          // Occasions and gender are never negated
          for (var occasion in OCCASIONS) {
            if (!matched && inList(OCCASIONS[occasion].words, chunk, single)) { out.occasion = out.occasion || occasion; matched = true; }
          }
          if (!matched && n === 1 && inList(GENDER_WORDS.men, chunk, single)) { out.gender = out.gender || 'men'; matched = true; }
          if (!matched && n === 1 && inList(GENDER_WORDS.women, chunk, single)) { out.gender = out.gender || 'women'; matched = true; }
          if (!matched && (LASTING_WORDS.indexOf(chunk) !== -1 || LASTING_WORDS.indexOf(single) !== -1)) {
            if (!negate) out.lasting = true;
            if (n === 1 && (WORDS[chunk] || WORDS[single])) addVec(out.vec, WORDS[chunk] || WORDS[single], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched && STRONG_WORDS.indexOf(chunk) !== -1) { out.intensity += negate ? -0.6 : 0.6; matched = true; }
          if (!matched && LIGHT_WORDS.indexOf(chunk) !== -1) {
            out.intensity += negate ? 0.4 : -0.6;
            if (WORDS[chunk]) addVec(out.vec, WORDS[chunk], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched && n === 1 && (WORDS[chunk] || WORDS[single])) {
            addVec(out.vec, WORDS[chunk] || WORDS[single], negate ? -0.9 : 1);
            matched = true;
          }
          if (!matched) {
            var note = exactNote(chunk) || exactNote(single);
            if (note) {
              var list = negate ? out.avoids : out.loves;
              if (list.indexOf(note.key) === -1) list.push(note.key);
              if (!negate) addVec(out.vec, note.facets, 0.9);
              matched = true;
            }
          }
          if (matched) { out.hits++; i += n - 1; break; }

          // Nothing recognised: try once more with the spelling fixed
          if (n === 1 && !corrected[i]) {
            corrected[i] = true;
            var fixed = fixTypo(word) || fixTypo(single);
            if (fixed) { words[i] = fixed; i--; break; }
          }
        }
      }
      out.intensity = clamp(out.intensity, -1, 1);
      return out;
    }

    // Preferences -> one accord vector
    function taste(prefs) {
      var vec = emptyVec();
      (prefs.vibes || []).forEach(function (vibe) { if (VIBES[vibe]) addVec(vec, VIBES[vibe], 1); });
      if (prefs.occasion && OCCASIONS[prefs.occasion]) addVec(vec, OCCASIONS[prefs.occasion].v, 0.6);
      (prefs.loves || []).forEach(function (key) { var hit = lookupNote(key); if (hit) addVec(vec, hit.facets, 0.7); });
      if (prefs.textVec) addVec(vec, prefs.textVec, 1);
      (prefs.avoids || []).forEach(function (key) { var hit = lookupNote(key); if (hit) addVec(vec, hit.facets, -0.25); });
      return vec;
    }

    function rank(products, prefs) {
      var user = taste(prefs);
      var hasTaste = maxOf(user) > 0;
      var wanted = clamp((prefs.intensity || 0) + (prefs.occasion && OCCASIONS[prefs.occasion] ? OCCASIONS[prefs.occasion].i * 0.5 : 0), -1, 1);
      var useStrength = prefs.intensity != null || !!prefs.occasion;
      var loves = prefs.loves || [], avoids = prefs.avoids || [];

      var scored = products.map(function (product) {
        var p = product.profile;
        var similarity = hasTaste ? cosine(user, p.vec) : 0.5;
        var loved = loves.filter(function (key) { return p.keys[key]; });
        var avoided = avoids.filter(function (key) { return p.keys[key]; });
        var score = loves.length ? similarity * 0.68 + (loved.length / loves.length) * 0.32 : similarity;

        // Accords the user pushed away (from "not sweet" style text) cost points when the perfume leans on them
        FACETS.forEach(function (f) { if (user[f] < 0) score -= Math.min(0.3, -user[f] * 0.28) * p.vec[f]; });
        score -= avoided.length * 0.22;
        if (useStrength) score -= Math.abs(wanted - p.strength) * 0.09;
        // Staying power: the most concentrated strength, and a base built on woods, amber or musk
        if (prefs.lasting) score += (p.extrait ? 0.08 : 0) + Math.min(1, p.anchors.length / 4) * 0.05;

        var occasionHit = false;
        if (prefs.occasion && product.tag) {
          var line = ' ' + product.tag.toLowerCase() + ' ';
          occasionHit = OCCASIONS[prefs.occasion].words.some(function (w) { return line.indexOf(w) !== -1; });
          if (occasionHit) score += 0.07;
        }

        var genderOk = !prefs.gender || prefs.gender === 'any' || product.g === 'unisex' || product.g === prefs.gender;
        if (product.avail === false) score -= 0.05;

        return { product: product, score: score, similarity: similarity, loved: loved, avoided: avoided, occasionHit: occasionHit, genderOk: genderOk };
      });

      var pool = scored.filter(function (row) { return row.genderOk; });
      if (pool.length < 3) pool = scored;
      pool.sort(function (a, b) { return b.score - a.score; });
      pool.forEach(function (row) { row.percent = Math.round(clamp(56 + 42 * clamp(row.score, 0, 1), 50, 98)); });
      return { user: user, rows: pool };
    }

    // Which notes in a perfume carry the accords the user asked for
    function reasons(row, user, limit) {
      var p = row.product.profile, out = [];
      var wantedFacets = FACETS.filter(function (f) { return user[f] > 0 && p.vec[f] >= 0.35; })
        .sort(function (a, b) { return user[b] * p.vec[b] - user[a] * p.vec[a]; }).slice(0, limit || 3);
      var used = {};
      wantedFacets.forEach(function (facet) {
        var carriers = p.notes.filter(function (note) { return (note.facets[facet] || 0) >= 0.6 && !used[note.key]; })
          .sort(function (a, b) { return (row.loved.indexOf(b.key) !== -1) - (row.loved.indexOf(a.key) !== -1) || b.facets[facet] - a.facets[facet]; })
          .filter(function (note, index, list) { return list.findIndex(function (other) { return other.key === note.key; }) === index; })
          .slice(0, 3);
        carriers.forEach(function (note) { used[note.key] = true; });
        if (carriers.length) out.push({ facet: facet, notes: carriers.map(function (note) { return note.name; }) });
      });
      return out;
    }

    // 8 readable axes for the chart
    var AXES = [
      ['Citrus', { citrus: 1 }], ['Fresh', { fresh: 0.7, green: 0.5 }], ['Fruity', { fruity: 1 }], ['Floral', { floral: 1 }],
      ['Sweet', { sweet: 1 }], ['Spicy', { spicy: 1 }], ['Warm', { amber: 0.7, leather: 0.4, musk: 0.2 }], ['Woody', { woody: 1 }]
    ];
    function axes(vec) {
      var values = AXES.map(function (axis) { var sum = 0; for (var f in axis[1]) sum += Math.max(0, vec[f] || 0) * axis[1][f]; return sum; });
      var m = Math.max.apply(null, values);
      return values.map(function (value) { return m > 0 ? value / m : 0; });
    }
    function topFacets(vec, count) {
      return FACETS.filter(function (f) { return vec[f] > 0; }).sort(function (a, b) { return vec[b] - vec[a]; })
        .filter(function (f, index, list) { return vec[f] >= vec[list[0]] * 0.45; }).slice(0, count || 3);
    }

    return {
      FACETS: FACETS, AXES: AXES.map(function (axis) { return axis[0]; }), VIBES: VIBES, OCCASIONS: OCCASIONS,
      lookupNote: lookupNote, parsePyramid: parsePyramid, profile: profile, readText: readText, taste: taste,
      rank: rank, reasons: reasons, axes: axes, topFacets: topFacets, emptyVec: emptyVec
    };
  })();

  /* ---------- Interface ---------- */
  (function () {
    var E = ScentEngine;
    var STEPS = ['who', 'vibe', 'occasion', 'notes', 'strength'];
    var STORE_KEY = 'stallion-scent-finder';
    var FACET_LABELS = { citrus: 'Citrus', fresh: 'Fresh', green: 'Aromatic', fruity: 'Fruity', floral: 'Floral', spicy: 'Spicy', sweet: 'Sweet', woody: 'Woody', amber: 'Warm amber', musk: 'Soft musk', leather: 'Smoky' };
    var FACET_COLORS = { citrus: '#f4c542', fresh: '#4fc3e8', green: '#6fbf73', fruity: '#ff6b8b', floral: '#e59bd6', spicy: '#e2622b', sweet: '#f0b27a', woody: '#9c6b43', amber: '#e8941a', musk: '#d8cfc4', leather: '#8a6a5c' };
    var DEFAULT_COLORS = ['#ff2e12', '#e8941a', '#4fc3e8'];
    var VIBE_LABELS = { fresh: 'Fresh & clean', cozy: 'Warm & cozy', bold: 'Bold & spicy', fruity: 'Sweet & fruity', floral: 'Soft & floral', woody: 'Deep & woody' };
    var OCCASION_LABELS = { everyday: 'Every day', date: 'Date night', night: 'Nights out', sunny: 'Sunny days', special: 'Special occasions', cold: 'Cold weather' };
    // Family words and aroma-chemical names are matched on, but not offered as chips
    var NOT_A_CHIP = /(notes|accord|fruits|spices|herbs|resins)$|^(citrus|calone|hedione|mahonial|akigalawood|cashmeran|ambroxan|ambrette|cypriol|elemi|labdanum|papyrus|benzoin|amberwood)$/;
    var CHIP_LIMIT = 26;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function esc(value) {
      return String(value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }
    function joinAnd(list) {
      if (list.length < 2) return list.join('');
      return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
    }
    function blankPrefs() {
      return { gender: null, vibes: [], occasion: null, loves: [], avoids: [], intensity: null, lasting: false, textVec: null, text: '' };
    }

    function init(root) {
      if (root.dataset.sfReady) return;
      root.dataset.sfReady = 'true';

      function $(selector) { return root.querySelector(selector); }
      function $$(selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

      var data = [];
      try { data = JSON.parse($('[data-sf-data]').textContent) || []; } catch (error) { data = []; }

      var noteCount = {}, noteNames = {}, noteFacets = {}, noteImages = {}, exactImage = {};
      // A picture named exactly like the note ("Vanilla") wins over a relative's ("Bourbon Vanilla")
      function addNoteImage(entry) {
        if (!entry || !entry.img) return;
        var hit = E.lookupNote(entry.l);
        if (!hit) return;
        var exact = String(entry.l).toLowerCase().trim() === hit.key;
        if (!noteImages[hit.key] || (exact && !exactImage[hit.key])) { noteImages[hit.key] = entry.img; exactImage[hit.key] = exact; }
      }
      var products = data.filter(function (product) {
        product.profile = E.profile(product);
        if (product.profile.notes.length < 3) return false;
        var counted = {};
        product.profile.notes.forEach(function (note) {
          if (!Object.keys(note.facets).length || counted[note.key]) return;
          counted[note.key] = true;
          noteCount[note.key] = (noteCount[note.key] || 0) + 1;
          noteNames[note.key] = note.name;
          noteFacets[note.key] = note.facets;
        });
        (product.main || []).forEach(addNoteImage);
        return true;
      });

      var allNoteImages = [];
      try { allNoteImages = JSON.parse($('[data-sf-note-images]').textContent) || []; } catch (error) { allNoteImages = []; }
      allNoteImages.forEach(addNoteImage);

      var cards = {};
      $$('[data-sf-card]').forEach(function (card) { cards[card.getAttribute('data-sf-card')] = card; });

      var prefs = blankPrefs();
      var current = 'intro';
      var timer = null;
      var pool = $('[data-sf-pool]');
      var textarea = $('[data-sf-text]');
      var errorEl = $('[data-sf-error]');
      var wordsEl = $('[data-sf-words]');
      var emptyWords = wordsEl.textContent;

      $('[data-sf-stat]').textContent = products.length
        ? products.length + ' perfumes · ' + Object.keys(noteCount).length + ' notes read'
        : '';

      /* ----- Radar ----- */
      var AXIS_COUNT = E.AXES.length;
      var shapes = { you: $('[data-sf-shape="you"]'), match: $('[data-sf-shape="match"]') };
      var shapeValues = { you: E.AXES.map(function () { return 0; }), match: E.AXES.map(function () { return 0; }) };
      var shapeFrames = {};

      function point(index, radius) {
        var angle = (-90 + (360 / AXIS_COUNT) * index) * Math.PI / 180;
        return [Math.cos(angle) * radius, Math.sin(angle) * radius];
      }
      function polygon(values, radius) {
        return values.map(function (value, index) { var p = point(index, value * radius); return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
      }
      (function drawGrid() {
        var html = '';
        [1 / 3, 2 / 3, 1].forEach(function (scale) {
          html += '<polygon class="scent-finder__ring" points="' + polygon(E.AXES.map(function () { return scale; }), 100) + '"></polygon>';
        });
        E.AXES.forEach(function (label, index) {
          var end = point(index, 100), at = point(index, 116);
          var anchor = Math.abs(at[0]) < 1 ? 'middle' : at[0] > 0 ? 'start' : 'end';
          html += '<line class="scent-finder__spoke" x1="0" y1="0" x2="' + end[0].toFixed(1) + '" y2="' + end[1].toFixed(1) + '"></line>';
          html += '<text data-sf-axis="' + index + '" x="' + at[0].toFixed(1) + '" y="' + at[1].toFixed(1) + '" text-anchor="' + anchor + '" dominant-baseline="middle">' + esc(label) + '</text>';
        });
        $('[data-sf-radar-grid]').innerHTML = html;
      })();

      function drawShape(name, target) {
        var el = shapes[name], from = shapeValues[name].slice(), start = null;
        var visible = target.some(function (value) { return value > 0; });
        el.style.opacity = visible ? 1 : 0;
        cancelAnimationFrame(shapeFrames[name]);
        if (reduceMotion || !visible) { shapeValues[name] = target.slice(); el.setAttribute('points', polygon(target, 100)); return; }
        function frame(now) {
          if (start === null) start = now;
          var t = Math.min(1, (now - start) / 420), eased = 1 - Math.pow(1 - t, 3);
          shapeValues[name] = from.map(function (value, index) { return value + (target[index] - value) * eased; });
          el.setAttribute('points', polygon(shapeValues[name], 100));
          if (t < 1) shapeFrames[name] = requestAnimationFrame(frame);
        }
        shapeFrames[name] = requestAnimationFrame(frame);
      }

      function updateStudio(match) {
        var vec = E.taste(prefs);
        var values = E.axes(vec);
        var top = E.topFacets(vec, 3);
        drawShape('you', values);
        drawShape('match', match ? E.axes(match.profile.vec) : E.AXES.map(function () { return 0; }));

        wordsEl.textContent = top.length ? top.map(function (facet) { return FACET_LABELS[facet]; }).join(' · ') : emptyWords;
        var palette = (match && !top.length ? E.topFacets(match.profile.vec, 3) : top).map(function (facet) { return FACET_COLORS[facet]; });
        [0, 1, 2].forEach(function (index) {
          root.style.setProperty('--sf-c' + (index + 1), palette[index] || palette[0] || DEFAULT_COLORS[index]);
        });
        $$('[data-sf-axis]').forEach(function (label) {
          label.classList.toggle('is-strong', values[Number(label.getAttribute('data-sf-axis'))] >= 0.7);
        });

        var legend = $('[data-sf-legend]');
        legend.hidden = !match;
        if (match) $('[data-sf-legend-match]').textContent = match.t;
      }

      /* ----- Screens ----- */
      function show(name, quiet) {
        clearTimeout(timer);
        current = name;
        $$('[data-sf-screen]').forEach(function (screen) {
          var active = screen.getAttribute('data-sf-screen') === name;
          screen.hidden = !active;
          screen.classList.toggle('is-active', active);
        });

        var step = STEPS.indexOf(name);
        $('[data-sf-bar]').hidden = step === -1;
        if (step !== -1) {
          $$('[data-sf-progress] span').forEach(function (bar, index) { bar.classList.toggle('is-done', index <= step); });
          $('[data-sf-count]').textContent = (step + 1) + ' / ' + STEPS.length;
        }
        if (quiet) return;

        var heading = $('[data-sf-screen="' + name + '"] .scent-finder__title');
        if (heading && name !== 'intro') heading.focus({ preventScroll: true });
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      function syncChoices() {
        $$('[data-sf-choice]').forEach(function (button) {
          var key = button.getAttribute('data-sf-choice'), value = button.getAttribute('data-value'), pressed = false;
          if (key === 'vibes') pressed = prefs.vibes.indexOf(value) !== -1;
          else if (key === 'gender') pressed = prefs.gender === value;
          else if (key === 'occasion') pressed = value !== '' && prefs.occasion === value;
          else if (key === 'intensity') pressed = prefs.intensity !== null && prefs.intensity === parseFloat(value);
          button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        });
        $$('[data-sf-note]').forEach(function (chip) {
          var key = chip.getAttribute('data-sf-note');
          var state = prefs.loves.indexOf(key) !== -1 ? 'love' : prefs.avoids.indexOf(key) !== -1 ? 'avoid' : '';
          chip.setAttribute('data-state', state);
          chip.setAttribute('aria-label', noteNames[key] + (state ? ': ' + state : ''));
        });
        var vibeNext = $('[data-sf-screen="vibe"] [data-sf-next]');
        if (vibeNext) vibeNext.disabled = !prefs.vibes.length;
        var notesNext = $('[data-sf-screen="notes"] [data-sf-next]');
        if (notesNext) {
          var picked = $$('[data-sf-note][data-state="love"], [data-sf-note][data-state="avoid"]').length;
          notesNext.textContent = notesNext.getAttribute(picked ? 'data-label-filled' : 'data-label-empty');
        }
      }

      function buildChips() {
        var keys = Object.keys(noteCount)
          .filter(function (key) { return !NOT_A_CHIP.test(key); })
          .sort(function (a, b) { return noteCount[b] - noteCount[a]; });
        // Keep the grid consistent: once enough notes have a picture, only offer those
        var pictured = keys.filter(function (key) { return noteImages[key]; });
        if (pictured.length >= 12) keys = pictured;
        keys = keys.slice(0, CHIP_LIMIT);
        function lead(key) {
          var facets = noteFacets[key], best = null;
          for (var facet in facets) if (best === null || facets[facet] > facets[best]) best = facet;
          return best;
        }
        keys.sort(function (a, b) { return E.FACETS.indexOf(lead(a)) - E.FACETS.indexOf(lead(b)) || noteCount[b] - noteCount[a]; });
        $('[data-sf-notes]').innerHTML = keys.map(function (key) {
          var picture = noteImages[key]
            ? '<img src="' + esc(noteImages[key]) + '" alt="" width="44" height="44" loading="lazy">'
            : '<i style="--note-color:' + FACET_COLORS[lead(key)] + '"></i>';
          return '<button type="button" class="scent-finder__note" data-sf-note="' + esc(key) + '" data-state="">' + picture + '<span>' + esc(noteNames[key]) + '</span></button>';
        }).join('');
      }

      function advance() {
        var step = STEPS.indexOf(current);
        if (step === -1) return;
        if (step === STEPS.length - 1) finish();
        else show(STEPS[step + 1]);
      }
      function advanceSoon() {
        clearTimeout(timer);
        timer = setTimeout(advance, reduceMotion ? 0 : 260);
      }

      /* ----- Results ----- */
      function noteName(key) {
        return noteNames[key] || key.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
      }

      function readChips(user) {
        var chips = [];
        if (prefs.text) chips.push('“' + (prefs.text.length > 64 ? prefs.text.slice(0, 61) + '…' : prefs.text) + '”');
        if (prefs.gender === 'men') chips.push('For him');
        if (prefs.gender === 'women') chips.push('For her');
        prefs.vibes.forEach(function (vibe) { chips.push(VIBE_LABELS[vibe]); });
        if (prefs.occasion) chips.push(OCCASION_LABELS[prefs.occasion]);
        if (prefs.loves.length) chips.push('Loves ' + joinAnd(prefs.loves.map(noteName)).toLowerCase());
        if (prefs.avoids.length) chips.push('No ' + joinAnd(prefs.avoids.map(noteName)).toLowerCase());
        E.FACETS.forEach(function (facet) { if (user[facet] < -0.3) chips.push('Less ' + FACET_LABELS[facet].toLowerCase()); });
        if (prefs.intensity !== null && prefs.intensity < 0) chips.push('Light');
        if (prefs.intensity !== null && prefs.intensity > 0) chips.push('Bold');
        if (prefs.lasting) chips.push('Long lasting');
        return chips;
      }

      function fillCard(card, row, index, user) {
        var product = row.product, profile = product.profile;
        card.querySelector('[data-sf-percent]').textContent = row.percent + '%';
        card.querySelector('[data-sf-ring]').style.setProperty('--sf-percent', row.percent);
        card.querySelector('[data-sf-rank]').textContent = index === 0 ? 'Best match' : '';

        var why = [];
        if (row.loved.length) {
          why.push('<li style="--dot:#ff2e12">Has the ' + joinAnd(row.loved.map(function (key) { return '<b>' + esc(noteName(key).toLowerCase()) + '</b>'; })) + ' you love</li>');
        }
        var because = E.reasons(row, user, index === 0 ? 3 : 2);
        if (!because.length && !row.loved.length) {
          E.topFacets(profile.vec, 2).forEach(function (facet) {
            var carriers = profile.notes.filter(function (note) { return (note.facets[facet] || 0) >= 0.6; }).slice(0, 3).map(function (note) { return note.name; });
            if (carriers.length) because.push({ facet: facet, notes: carriers });
          });
        }
        because.forEach(function (reason) {
          why.push('<li style="--dot:' + FACET_COLORS[reason.facet] + '"><b>' + FACET_LABELS[reason.facet] + '</b> from ' + esc(joinAnd(reason.notes).toLowerCase()) + '</li>');
        });
        if (prefs.lasting && (profile.extrait || profile.anchors.length)) {
          var hold = profile.extrait ? 'Extrait de Parfum, the most concentrated strength' : '';
          if (profile.anchors.length) hold += (hold ? ', on a base of ' : 'A base of ') + esc(joinAnd(profile.anchors.slice(0, 3)).toLowerCase());
          why.push('<li style="--dot:#1b1b1b"><b>Made to stay</b>: ' + hold + '</li>');
        }
        if (row.avoided.length) {
          why.push('<li style="--dot:#9a9a9a">Heads-up: it does contain ' + esc(joinAnd(row.avoided.map(noteName)).toLowerCase()) + '</li>');
        }
        card.querySelector('[data-sf-why]').innerHTML = why.join('');

        var layers = [['Top', 'top'], ['Heart', 'heart'], ['Base', 'base']];
        card.querySelector('[data-sf-pyramid]').innerHTML = layers.map(function (layer) {
          var notes = profile.layers[layer[1]];
          if (!notes.length) return '';
          var text = notes.map(function (raw) {
            var hit = E.lookupNote(raw);
            return hit && prefs.loves.indexOf(hit.key) !== -1 ? '<mark>' + esc(raw) + '</mark>' : esc(raw);
          }).join(', ');
          return '<div><dt>' + layer[0] + '</dt><dd>' + text + '</dd></div>';
        }).join('');
      }

      function renderResults() {
        var result = E.rank(products, prefs);
        var rows = result.rows.filter(function (row) { return cards[row.product.h]; }).slice(0, 3);
        if (!rows.length) return false;

        Object.keys(cards).forEach(function (handle) { pool.appendChild(cards[handle]); });
        rows.forEach(function (row, index) {
          var card = cards[row.product.h];
          fillCard(card, row, index, result.user);
          $(index === 0 ? '[data-sf-slot="hero"]' : '[data-sf-slot="runners"]').appendChild(card);
        });

        $('[data-sf-results-title]').textContent = 'Meet ' + rows[0].product.t;
        $('[data-sf-read]').innerHTML = readChips(result.user).map(function (chip) { return '<span>' + esc(chip) + '</span>'; }).join('');
        updateStudio(rows[0].product);

        try { sessionStorage.setItem(STORE_KEY, JSON.stringify(prefs)); } catch (error) {}
        root.dispatchEvent(new CustomEvent('scent-finder:result', {
          bubbles: true,
          detail: { preferences: prefs, matches: rows.map(function (row) { return { handle: row.product.h, title: row.product.t, percent: row.percent }; }) }
        }));
        return true;
      }

      function finish() {
        if (!products.length) return;
        $('[data-sf-blend]').textContent = 'Blending ' + products.length + ' perfumes against your taste…';
        show('loading');
        timer = setTimeout(function () {
          if (renderResults()) show('results');
          else show('intro');
        }, reduceMotion ? 200 : 1100);
      }

      function ask() {
        var text = textarea.value.trim();
        errorEl.hidden = true;
        if (!text) { textarea.focus(); return; }
        var read = E.readText(text);
        if (!read.hits) {
          errorEl.textContent = 'I couldn’t pick a scent out of that. Try words like fresh, sweet or woody, a note like vanilla, or an occasion like date night — or take the quiz below.';
          errorEl.hidden = false;
          return;
        }
        prefs = blankPrefs();
        prefs.text = text;
        prefs.textVec = read.vec;
        prefs.gender = read.gender;
        prefs.occasion = read.occasion;
        prefs.loves = read.loves;
        prefs.avoids = read.avoids;
        prefs.intensity = read.intensity ? read.intensity : null;
        prefs.lasting = read.lasting;
        syncChoices();
        updateStudio();
        finish();
      }

      function reset() {
        prefs = blankPrefs();
        textarea.value = '';
        errorEl.hidden = true;
        try { sessionStorage.removeItem(STORE_KEY); } catch (error) {}
        Object.keys(cards).forEach(function (handle) { pool.appendChild(cards[handle]); });
        syncChoices();
        updateStudio();
        show('intro');
      }

      /* ----- Events ----- */
      root.addEventListener('click', function (event) {
        var target = event.target.closest('[data-sf-choice], [data-sf-note], [data-sf-next], [data-sf-back], [data-sf-start], [data-sf-example], [data-sf-tune], [data-sf-reset]');
        if (!target || !root.contains(target)) return;

        if (target.hasAttribute('data-sf-choice')) {
          var key = target.getAttribute('data-sf-choice'), value = target.getAttribute('data-value');
          if (key === 'vibes') {
            var at = prefs.vibes.indexOf(value);
            if (at !== -1) prefs.vibes.splice(at, 1);
            else { prefs.vibes.push(value); if (prefs.vibes.length > 2) prefs.vibes.shift(); }
          } else if (key === 'gender') prefs.gender = value;
          else if (key === 'occasion') prefs.occasion = value || null;
          else if (key === 'intensity') prefs.intensity = parseFloat(value);
          syncChoices();
          if (key === 'occasion' && !value) target.setAttribute('aria-pressed', 'true');
          updateStudio();
          if (key !== 'vibes') advanceSoon();
        } else if (target.hasAttribute('data-sf-note')) {
          var note = target.getAttribute('data-sf-note');
          var loved = prefs.loves.indexOf(note), avoided = prefs.avoids.indexOf(note);
          if (loved !== -1) { prefs.loves.splice(loved, 1); prefs.avoids.push(note); }
          else if (avoided !== -1) prefs.avoids.splice(avoided, 1);
          else prefs.loves.push(note);
          syncChoices();
          updateStudio();
        } else if (target.hasAttribute('data-sf-next')) {
          advance();
        } else if (target.hasAttribute('data-sf-back')) {
          var step = STEPS.indexOf(current);
          show(step > 0 ? STEPS[step - 1] : 'intro');
        } else if (target.hasAttribute('data-sf-start') || target.hasAttribute('data-sf-tune')) {
          Object.keys(cards).forEach(function (handle) { pool.appendChild(cards[handle]); });
          updateStudio();
          show('who');
        } else if (target.hasAttribute('data-sf-example')) {
          textarea.value = target.textContent.trim();
          ask();
        } else if (target.hasAttribute('data-sf-reset')) {
          reset();
        }
      });

      $('[data-sf-ask]').addEventListener('submit', function (event) { event.preventDefault(); ask(); });
      textarea.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); ask(); }
      });
      textarea.addEventListener('input', function () { errorEl.hidden = true; });

      /* ----- Start ----- */
      buildChips();
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY)); } catch (error) { saved = null; }
      if (saved && products.length && Array.isArray(saved.vibes) && Array.isArray(saved.loves) && Array.isArray(saved.avoids)) {
        prefs = Object.assign(blankPrefs(), saved);
        textarea.value = prefs.text || '';
        syncChoices();
        if (renderResults()) show('results', true);
        else { prefs = blankPrefs(); syncChoices(); updateStudio(); }
      } else {
        syncChoices();
        updateStudio();
      }
    }

    function boot(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-scent-finder]'), init);
    }
    boot(document);
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
